export { default as AiUsagePage } from './AiUsagePage';

export const moduleConfig = {
  module: {
    title: 'AI Usage',
    description: 'Monitor LLM requests, token usage, and estimated cost per provider.',
  },
};
